/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_Overlay_Power_ShortInputs */

const bn_cipher_overlay_power_short = /** @type {(inputs: Cipher_Overlay_Power_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পিডব্লিউআর`)
};

const de_cipher_overlay_power_short = /** @type {(inputs: Cipher_Overlay_Power_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PWR`)
};

const el_cipher_overlay_power_short = /** @type {(inputs: Cipher_Overlay_Power_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PWR`)
};

const en_cipher_overlay_power_short = /** @type {(inputs: Cipher_Overlay_Power_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PWR`)
};

const es_cipher_overlay_power_short = /** @type {(inputs: Cipher_Overlay_Power_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PWR`)
};

const fr_cipher_overlay_power_short = /** @type {(inputs: Cipher_Overlay_Power_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ÉNERG`)
};

const hi_cipher_overlay_power_short = /** @type {(inputs: Cipher_Overlay_Power_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पीडब्लूआर`)
};

const hu_cipher_overlay_power_short = /** @type {(inputs: Cipher_Overlay_Power_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PWR`)
};

const id_cipher_overlay_power_short = /** @type {(inputs: Cipher_Overlay_Power_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PWR`)
};

const it_cipher_overlay_power_short = /** @type {(inputs: Cipher_Overlay_Power_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PWR`)
};

const ja_cipher_overlay_power_short = /** @type {(inputs: Cipher_Overlay_Power_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PWR`)
};

const ko_cipher_overlay_power_short = /** @type {(inputs: Cipher_Overlay_Power_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PWR`)
};

const nl_cipher_overlay_power_short = /** @type {(inputs: Cipher_Overlay_Power_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PWR`)
};

const pl_cipher_overlay_power_short = /** @type {(inputs: Cipher_Overlay_Power_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PWR`)
};

const pt_cipher_overlay_power_short = /** @type {(inputs: Cipher_Overlay_Power_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PWR`)
};

const ru_cipher_overlay_power_short = /** @type {(inputs: Cipher_Overlay_Power_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PWR`)
};

const sv_cipher_overlay_power_short = /** @type {(inputs: Cipher_Overlay_Power_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PWR`)
};

const tr_cipher_overlay_power_short = /** @type {(inputs: Cipher_Overlay_Power_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Güç`)
};

const uk_cipher_overlay_power_short = /** @type {(inputs: Cipher_Overlay_Power_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PWR`)
};

const vi_cipher_overlay_power_short = /** @type {(inputs: Cipher_Overlay_Power_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LÒ NÒ`)
};

const zh_cipher_overlay_power_short = /** @type {(inputs: Cipher_Overlay_Power_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`压水堆`)
};

const zh_hant_cipher_overlay_power_short = /** @type {(inputs: Cipher_Overlay_Power_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`壓水堆`)
};

/**
* | output |
* | --- |
* | "PWR" |
*
* @param {Cipher_Overlay_Power_ShortInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_overlay_power_short = /** @type {((inputs?: Cipher_Overlay_Power_ShortInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_Overlay_Power_ShortInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_overlay_power_short(inputs)
	if (locale === "de") return de_cipher_overlay_power_short(inputs)
	if (locale === "el") return el_cipher_overlay_power_short(inputs)
	if (locale === "en") return en_cipher_overlay_power_short(inputs)
	if (locale === "es") return es_cipher_overlay_power_short(inputs)
	if (locale === "fr") return fr_cipher_overlay_power_short(inputs)
	if (locale === "hi") return hi_cipher_overlay_power_short(inputs)
	if (locale === "hu") return hu_cipher_overlay_power_short(inputs)
	if (locale === "id") return id_cipher_overlay_power_short(inputs)
	if (locale === "it") return it_cipher_overlay_power_short(inputs)
	if (locale === "ja") return ja_cipher_overlay_power_short(inputs)
	if (locale === "ko") return ko_cipher_overlay_power_short(inputs)
	if (locale === "nl") return nl_cipher_overlay_power_short(inputs)
	if (locale === "pl") return pl_cipher_overlay_power_short(inputs)
	if (locale === "pt") return pt_cipher_overlay_power_short(inputs)
	if (locale === "ru") return ru_cipher_overlay_power_short(inputs)
	if (locale === "sv") return sv_cipher_overlay_power_short(inputs)
	if (locale === "tr") return tr_cipher_overlay_power_short(inputs)
	if (locale === "uk") return uk_cipher_overlay_power_short(inputs)
	if (locale === "vi") return vi_cipher_overlay_power_short(inputs)
	if (locale === "zh") return zh_cipher_overlay_power_short(inputs)
	return zh_hant_cipher_overlay_power_short(inputs)
});